import { get } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getApplicationList = async (page, pageSize = 10) => {
  const builder = new UrlBuilder(`/submissions/get-applications`);
  builder.add('page', page);
  builder.add('pageSize', pageSize);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getApplicationStatus = async (listId) => {
  const builder = new UrlBuilder(`/submissions/get-application-status/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getApplication = async (listId) => {
  const builder = new UrlBuilder(`/submissions/get-application`);
  builder.add('listId', listId);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
